import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
/////////////////////////////////////////////////////////////////////////////777
import { StickerCollection } from '@/core/interfaces';
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
import { setActiveCollection } from '@/core/redux/slices';

interface CollectionItemProps {
	collection: StickerCollection;
}

export const CollectionItem: React.FC<CollectionItemProps> = ({
	collection,
}) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();
	const dispatch = useCustomDispatch();
	const navigate = useNavigate();

	/*********************
	// #region Redux
	**********************/
	const { activeCollectionGroup } = useCustomSelector(
		(state) => state.collections
	);

	/*********************
	// #region Functions
	**********************/
	const handleRedirectToCollection = () => {
		if (!activeCollectionGroup) return;
		dispatch(
			setActiveCollection({
				groupId: activeCollectionGroup.id,
				collectionId: collection.id,
			})
		);
		navigate(`/collections/${activeCollectionGroup.id}/${collection.id}`);
	};

	/*********************
	// #region Template
	**********************/

	return (
		<div
			key={collection.id}
			className="flex flex-col gap-2 max-w-[150px] mx-auto"
		>
			<div
				className="grid grid-rows-3 grid-cols-3 w-[150px] h-[150px]"
				onClick={handleRedirectToCollection}
			>
				{collection.stickers.map((sticker, index) => {
					return (
						<img
							key={sticker.position.toString()}
							className={`mx-auto h-[50px] w-[50px] border-none ${
								index === 0
									? 'rounded-tl-lg'
									: index === 2
									? 'rounded-tr-lg'
									: index === 6
									? 'rounded-bl-lg'
									: index === 8
									? 'rounded-br-lg'
									: 'none'
							}`}
							src={sticker.image}
							alt={sticker.position.toString()}
						/>
					);
				})}
			</div>
			<div className="flex flex-col text-center">
				<p className="font-semibold">{collection.title}</p>
				<p className="text-sm ">
					{t('collected')}: {collection.numStickersCollected}
					/9
				</p>
			</div>
		</div>
	);
};
